module.exports = __webpack_public_path__ + "static/media/item_24_1.bd701d3f.png";